import React, { FC } from 'react';
import { BreadcrumbLinkFragment, BreadcrumbTextFragment } from '../../graphql/__generated__/types';
import { UitkBreadcrumbs } from 'uitk-react-breadcrumbs';
import { Link } from 'react-router-dom';
import { getPathName } from '../../utils/common';
import { UitkLink } from 'uitk-react-link';
import { UitkText } from 'uitk-react-text';

export interface BreadcrumbsProps {
  crumbs: Array<BreadcrumbTextFragment | BreadcrumbLinkFragment>;
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ crumbs }: BreadcrumbsProps) => {
  if (!crumbs || crumbs.length === 0) return null;

  const crumbsLinks = crumbs.map((crumb) =>
    crumb.__typename === 'EGDSStandardLink' ? (
      <UitkLink inline size="small">
        <Link to={getPathName(crumb.action.resource.value)}>{crumb.text}</Link>
      </UitkLink>
    ) : (
      <UitkText size={200}>{crumb.text}</UitkText>
    )
  );

  return <UitkBreadcrumbs hasDynamicInlineCrumbs crumbs={crumbsLinks} />;
};
